import React, { useCallback, useEffect } from 'react'

import { COLOR } from '../../../../design-tokens'
import { parseKingTableUrl } from '../../../../../app/ecommerce/common/components/choose-order-type/utils'
import { QRCodeScannerModal } from '../../../../../app/common/qr-code-scanner/QRCodeScannerModal'
import { push } from 'connected-react-router'
import { useDispatch } from 'react-redux'
import { useIntl } from 'react-intl'
import { isMobile, isTablet } from 'react-device-detect'
import { useHistory } from 'react-router-dom/cjs/react-router-dom'

export const KingTableScanScreen = () => {
    const intl = useIntl()
    const history = useHistory()

    useEffect(() => {
        if (!isMobile && !isTablet) {
            history.push(
                intl.formatMessage({ id: 'routes.kingtable.no-desktop' })
            )
        }
    }, [history, intl])

    const goToKingTable = useCallback(
        (params: {
            restaurant: string,
            table: string,
            terrace: string,
            token: string
        }) => {
            const urlParam = new URLSearchParams()
            urlParam.set('restaurant', params.restaurant)
            urlParam.set('table', params.table)
            urlParam.set('terrace', params.terrace)
            urlParam.set('token', params.token)
            close()
            history.push(
                intl.formatMessage({
                    id: 'routes.kingtable.full'
                }) + `?${urlParam.toString()}`
            )
        },
        [close, history, intl]
    )

    return (
        <QRCodeScannerModal
            helpText={intl.formatMessage({
                id: 'ecommerce.kingtable.scan.description'
            })}
            open={true}
            idleColor={COLOR.PRIMARY}
            onScan={result => {
                const parsed = parseKingTableUrl(result)

                if (!parsed) {
                    throw new Error(
                        intl.formatMessage({
                            id: 'qr.code.table.error'
                        })
                    )
                }

                goToKingTable(parsed)
            }}
        />
    )
}
